import React from 'react';
import {Redirect, withRouter } from 'react-router-dom';
import auth0Client from './Auth';

type myState = { 
    redirect: boolean,
   };

type myProps = {}
class Callback extends React.Component<myProps, myState> {
    constructor(props: any) {
        super(props);
        this.state = {
            redirect: false
        }
    }
    async componentDidMount() {
        await auth0Client.handleAuthentication().catch((err) => console.log("error",err))
        this.setState({redirect: true})
    }

    render() {
        if (this.state.redirect){
            return  <Redirect to={'/'} push/>

        }
        return (
            <div>
                <p>Loading profile...</p>
            </div>
        );
    }
}

export default withRouter(Callback);


// WEBPACK FOOTER //
// ./src/components/Login/Callback.tsx